import React from 'react';
import './AboutUsSection.css';

type SocialItem = {
  shortLabel: string;
  name: string;
};

const socialItems: SocialItem[] = [
  { shortLabel: 'IG', name: 'Instagram' },
  { shortLabel: 'X', name: 'X' },
  { shortLabel: 'FB', name: 'Facebook' },
  { shortLabel: 'IN', name: 'LinkedIn' },
];

function AboutUsSection() {
  return (
    <section className="new-site-about-us-root" aria-label="Hakkımızda">
      <div className="new-site-about-us-grid">
        <div className="new-site-about-us-content">
          <h2 className="new-site-about-us-heading">Hakkımızda</h2>

          <p className="new-site-about-us-description">
            Öğretmenlerin ders hazırlık sürecini kolaylaştırmak için kullanışlı, erişilebilir ve
            paylaşılabilir kaynakları bir araya getiriyoruz. Amacımız öğretmenlerin zamandan tasarruf
            etmesine ve sınıflarında daha fazla ilham yaratmasına yardımcı olmak.
          </p>

          <div className="new-site-about-us-contact-block">
            <div className="new-site-about-us-contact-label">Bize ulaşın</div>
            <a
              className="new-site-about-us-email-link"
              href="mailto:iletisim@siteadi.com"
            >
              iletisim@siteadi.com
            </a>
          </div>

          <div className="new-site-about-us-social-block">
            <div className="new-site-about-us-contact-label">Bizi takip edin</div>

            <div className="new-site-about-us-social-row" aria-hidden="true">
              {socialItems.map((item) => (
                <span key={item.name} className="new-site-about-us-social-pill" title={item.name}>
                  {item.shortLabel}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="new-site-about-us-photo-panel" aria-hidden="false">
          <div className="new-site-about-us-photo-frame">
            <img
              className="new-site-about-us-photo"
              src="/images/about-us/about-us-teachers.jpg"
              alt="Sınıf ortamında çalışan öğretmenler"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutUsSection;